"use strict";
import { ALL_CHAIN_IDS } from "features/chains/types";
export function useFeatureFlaggedChainIds() {
  return ALL_CHAIN_IDS;
}
